import React, { useState } from 'react';
import { SimulatorDetailsModel } from '../../../models/superbit-api-models';
import {
    INSURANCE_START_DATE_OPTIONS,
    YES_NO_OPTIONS,
} from '../simulatorSettings.constants';
import './GeneralSettings.css';

interface GeneralSettingsProps {
    details?: SimulatorDetailsModel;
    onSave: (details: SimulatorDetailsModel) => Promise<void>;
}

/** "כללי" tab — the public/global simulator details (was _PublicSettings.cshtml). */
const GeneralSettings: React.FC<GeneralSettingsProps> = ({ details, onSave }) => {
    const [postalCode, setPostalCode] = useState<string>(details?.postalCode ?? '');
    const [insuranceStartDate, setInsuranceStartDate] = useState<number>(
        details?.insuranceStartDate ?? Number(INSURANCE_START_DATE_OPTIONS[0].value)
    );
    const [drivingOnShabbat, setDrivingOnShabbat] = useState<number>(
        details?.drivingOnShabbat ?? Number(YES_NO_OPTIONS[0].value)
    );
    const [saving, setSaving] = useState(false);
    const [feedback, setFeedback] = useState<{ ok: boolean; msg: string } | null>(null);

    const handleSave = async () => {
        setSaving(true);
        setFeedback(null);
        try {
            const model = SimulatorDetailsModel.fromJS({
                postalCode,
                insuranceStartDate,
                drivingOnShabbat,
            });
            await onSave(model);
            setFeedback({ ok: true, msg: 'הנתונים נשמרו בהצלחה' });
        } catch (e) {
            setFeedback({ ok: false, msg: 'שמירת הנתונים נכשלה' });
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="sbsim-general">
            <div className="sbsim-general__field">
                <label className="sbsim-general__label" htmlFor="sbsim-postal-code">
                    מיקוד
                </label>
                <input
                    id="sbsim-postal-code"
                    className="sbsim-general__input"
                    type="text"
                    placeholder="מיקוד"
                    value={postalCode}
                    onChange={(e) => setPostalCode(e.target.value)}
                />
            </div>

            <div className="sbsim-general__field">
                <label className="sbsim-general__label" htmlFor="sbsim-insurance-start">
                    מועד תחילת הביטוח
                </label>
                <select
                    id="sbsim-insurance-start"
                    className="sbsim-general__select"
                    value={insuranceStartDate}
                    onChange={(e) => setInsuranceStartDate(Number(e.target.value))}
                >
                    {INSURANCE_START_DATE_OPTIONS.map((o) => (
                        <option key={o.value} value={o.value}>
                            {o.label}
                        </option>
                    ))}
                </select>
            </div>

            <div className="sbsim-general__field">
                <label className="sbsim-general__label" htmlFor="sbsim-driving-shabbat">
                    נהיגה בשבת
                </label>
                <select
                    id="sbsim-driving-shabbat"
                    className="sbsim-general__select"
                    value={drivingOnShabbat}
                    onChange={(e) => setDrivingOnShabbat(Number(e.target.value))}
                >
                    {YES_NO_OPTIONS.map((o) => (
                        <option key={o.value} value={o.value}>
                            {o.label}
                        </option>
                    ))}
                </select>
            </div>

            <div className="sbsim-general__actions">
                <button
                    type="button"
                    className="sbsim-general__save"
                    onClick={handleSave}
                    disabled={saving}
                >
                    {saving ? 'שומר...' : 'שמור הכל'}
                </button>
                {feedback && (
                    <span
                        className={`sbsim-general__feedback ${
                            feedback.ok
                                ? 'sbsim-general__feedback--ok'
                                : 'sbsim-general__feedback--err'
                        }`}
                    >
                        {feedback.msg}
                    </span>
                )}
            </div>
        </div>
    );
};

export default GeneralSettings;
